import { render, staticRenderFns } from "./TrashListItem.vue?vue&type=template&id=a42c162e&"
import script from "./TrashListItem.vue?vue&type=script&lang=js&"
export * from "./TrashListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports